/**
 * 외부 MCP 연결 상태(§7.5 상태 LED). 5초마다, 그리고 로그 배치가 올 때 다시 읽는다.
 * idle(세션 없음) · listening(브리지 대기) · connected(최근 60초 안 MCP 호출) · error(마지막 사건이 오류).
 */
import { useEffect, useState } from "react";
import { invoke, isDesktop, listen } from "./runtime";

export type ConnectionState = "idle" | "listening" | "connected" | "error";

export interface ConnectionStatus {
  state: ConnectionState;
  peer: string | null;
  lastCallAt: string | null;
  detail: string | null;
}

export const CONNECTION_LABEL: Record<ConnectionState, string> = {
  idle: "연결 없음",
  listening: "대기 중",
  connected: "연결됨",
  error: "오류",
};

export function connectionText(s: ConnectionStatus | null): string {
  if (!s) return "확인 중";
  const base = CONNECTION_LABEL[s.state];
  return s.state === "connected" && s.peer ? `${base} · ${s.peer}` : base;
}

export function useConnectionStatus(): ConnectionStatus | null {
  const [status, setStatus] = useState<ConnectionStatus | null>(null);
  useEffect(() => {
    if (!isDesktop()) return;
    let alive = true;
    let pending = false;
    const refresh = () => {
      if (pending) return;
      pending = true;
      void invoke<ConnectionStatus>("get_external_connection_status")
        .then((s) => alive && setStatus(s))
        .catch(() => {})
        .finally(() => {
          pending = false;
        });
    };
    refresh();
    const timer = window.setInterval(refresh, 5000);
    let off: (() => void) | null = null;
    void listen("xplanner://log-batch", refresh).then((fn) => (alive ? (off = fn) : fn()));
    return () => {
      alive = false;
      window.clearInterval(timer);
      off?.();
    };
  }, []);
  return status;
}
